import { Field } from 'formik'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { DateField } from '../../field'

interface Props {
  name: string
  label?: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  className?: string
}

export const DateInput: React.FunctionComponent<Props> = ({
  name,
  label,
  placeholder,
  required,
  disabled,
  ...rest
}) => {
  const intl = useIntl()
  const validate = useCallback(
    (value: Date | null): string | undefined => {
      if (required && !value) {
        return intl.formatMessage({ id: 'validation.requiredField' })
      }
      return undefined
    },
    [required, intl]
  )
  return (
    <Field
      {...rest}
      component={DateField}
      id={name}
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      validate={validate}
      disabled={disabled}
    />
  )
}
